import './Gallery.scss';
import { useEffect, useState } from 'react';
import LightboxY from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Video from 'yet-another-react-lightbox/plugins/video';

import { Grid, replaceItemInArray } from '@gcl/react-core';
import { IGalleryItem } from './gallery.models';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

import 'yet-another-react-lightbox/styles.css';
import { GalleryImage } from './GalleryItem';

interface IGallery {
  id: string;
  thumbnailWidth?: number;
  items: IGalleryItem[];
  className?: string;
  isExpanded?: boolean;
}

export const Gallery = ({ id, thumbnailWidth = 100, items, className, isExpanded = false }: IGallery) => {
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState<any[]>([]);
  const [slideIndex, setSlideIndex] = useState<number>(0);

  useEffect(() => {
    let loadingSlides: any[] = [];

    loadingSlides = items.map((i) => {
      if (i.imageSource.includes('youtube')) return { src: i.imageSource, type: 'youtube' };
      return { src: '/images/loading.gif' };
    });

    setSlides(loadingSlides);
  }, [JSON.stringify(items)]);

  const updateSlide = (index: number, source: string, mimeType: string | undefined) => {
    setSlides((old) => {
      if (mimeType === 'youtube') {
        return replaceItemInArray(
          old,
          {
            type: 'youtube',
            src: source,
          },
          index,
        );
      }
      if (mimeType?.startsWith('video')) {
        return replaceItemInArray(
          old,
          {
            type: 'video',
            sources: [
              {
                src: source,
                type: mimeType,
              },
            ],
          },
          index,
        );
      }
      return replaceItemInArray(old, { src: source }, index);
    });
  };

  const onClickThumbnail = (index: number) => {
    setSlideIndex(index);
    setOpen(true);
  };
  return (
    <>
      <>
        <Grid key={id} container className={`gcl-gems-gallery-container ${className}`}>
          <Grid container item direction="row" xs={12}>
            {items.map((i, index) => (
              <GalleryImage
                isVisibleInViewport={isExpanded}
                // eslint-disable-next-line react/no-array-index-key
                key={`gcl-gems-gallery-image-${index}`}
                item={i}
                index={index}
                thumbnailWidth={thumbnailWidth}
                onClickThumbnail={onClickThumbnail}
                updateSlide={updateSlide}
                shouldShowFirstThumbnail={index === 0 && items.length > 1}
              />
            ))}
          </Grid>
        </Grid>
      </>
      <LightboxY
        plugins={[Zoom, Thumbnails, Video]}
        open={open}
        index={slideIndex}
        close={() => setOpen(false)}
        slides={slides}
        carousel={{ finite: true }}
        render={{
          slide: (temp) => {
            const { slide: tempSlide, rect } = temp;
            const slide = tempSlide as { [key: string]: any };

            return slide.type === 'youtube' ? (
              <iframe
                width={Math.min(
                  ...[slide.width, rect.width, (slide.width * rect.height) / slide.height].filter(Number.isFinite),
                )}
                height={Math.min(
                  ...[slide.height, rect.height, (slide.height * rect.width) / slide.width].filter(Number.isFinite),
                )}
                src={slide.src}
                title={slide.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : undefined;
          },
        }}
      />
    </>
  );
};
